<form [formGroup]="form" class="h-full w-full">
  <mat-form-field class="h-full w-full" subscriptSizing="dynamic">
    <input
      matInput
      formControlName="dateTimeInput"
      [placeholder]="placeholder"
      rmsInputMask
      [mask]="dateTimeMask"
      [unmask]="dateTimeUnmask"
    />
    <input
      matInput
      class="!hidden"
      formControlName="dateCalendar"
      [matDatepicker]="picker"
      [min]="min"
      [max]="max"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker>
      <mat-datepicker-actions>
        <div class="flex flex-col gap-4 pt-4 w-full">
          <mat-divider></mat-divider>

          <rms-time-picker
            class="w-full"
            formControlName="timeInput"
            [interval]="interval"
          ></rms-time-picker>

          <mat-divider></mat-divider>

          <div class="flex justify-end">
            <button
              mat-stroked-button
              class="compact-button"
              matDatepickerCancel
            >
              {{ "libs.common.cancel" | translate }}
            </button>
            <button
              mat-raised-button
              color="primary"
              class="compact-button"
              matDatepickerApply
            >
              {{ "libs.common.select" | translate }}
            </button>
          </div>
        </div>
      </mat-datepicker-actions>
    </mat-datepicker>
  </mat-form-field>
</form>
